import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { OkCancelDialogComponent } from '../../../dialogs/ok-cancel/ok-cancel-dialog.component';
import { OkCancelData } from '../../../dialogs/ok-cancel/ok-cancel-dialog.model';
import { LexbeCase } from '../../../../models/case.model';
import { Account } from '../../../../models/ui/account.model';
import { CaseSdk } from '../../../../sdks/case.sdk';

@Component({
    selector: 'lex-move-case-dialog',
    templateUrl: './move-case-dialog.component.html',
    styleUrls: ['./move-case-dialog.component.scss'],
    standalone: false
})
export class MoveCaseDialogComponent {

	public selectedAccount: Account = null;
	public cases: LexbeCase[] = [];
	public moveCaseForm: UntypedFormGroup;
	public selectedCase: LexbeCase = null;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<MoveCaseDialogComponent>,
		private caseSdk: CaseSdk,
		@Inject(MAT_DIALOG_DATA) private inputAccount: Account) {
		this.selectedAccount = this.inputAccount;
		this.caseSdk.getCases().subscribe(data => this.cases = data);
		this.moveCaseForm = this.formBuilder.group({
			case: ['', [Validators.required]]
		});
	}

	public getCaseInfo(): void {
		this.selectedCase = this.cases.find(x => x.caseId === this.moveCaseForm.controls['case'].value);
	}

	public moveCaseToAccount(): void {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.width = '500px';

		dialogConfig.data = {
			title: `Move Case to Account Confirmation`,
			message: `${this.selectedCase.caseName} will move from
				${this.selectedCase.account.accountName} to ${this.selectedAccount.accountName}.`,
			showAcknowledge: true
		} as OkCancelData;

		this.dialog.open(OkCancelDialogComponent, dialogConfig)
			.afterClosed().subscribe((confirm) => {
				if (confirm) {
					this.selectedCase.accountId = this.selectedAccount.accountId;
					this.dialogRef.close(this.selectedCase);
				}
			})
	}
}
